<div class="chat-window">
  <div class="chat-window__overlay" *ngIf="loading">
    <div class="chat-window__spinner"></div>
  </div>

  <div class="chat-window__empty" *ngIf="!conversation && !loading">
    <span>{{ 'ai_chat.empty_state' | translate }}</span>
  </div>

  <deep-chat
    *ngIf="conversation"
    #deepChatEl
    class="chat-window__deep-chat"
    style="width: 100%; height: 100%; border: none; border-radius: 0;"
    [connect]="deepChatConnect"
    [messageStyles]="messageStyles"
    [textInput]="textInput"
    [submitButtonStyles]="submitButtonStyles"
    [auxiliaryStyle]="auxiliaryStyle"
  ></deep-chat>
</div>
